<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body>
              <b-card-body>
                <b-form v-if="!key" @submit="onRemember">
                  <h1 class="text-center">{{ t('remember_header') }}</h1>
                  <p class="text-muted text-center">{{ t('remember_info') }}</p>
                  <b-alert class="text-center" variant="danger" show v-if="form.remember.alert.danger">{{form.remember.alert.danger}}</b-alert>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text>@</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" v-model="form.remember.email" class="form-control" :placeholder="t('global_email')" autocomplete="username email" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="8" offset="2" class="text-center">
                      <b-button variant="primary" block class="px-4" @click="onRemember" :disabled="form.remember.locked">{{ t('remember_button') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
                <b-form v-else @submit="onChange">
                  <h1 class="text-center">{{ t('remember_header') }}</h1>
                  <p class="text-muted text-center"></p>
                  <b-alert class="text-center" variant="danger" show v-if="form.change.alert.danger">{{form.change.alert.danger}}</b-alert>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text>@</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="form.change.password1" class="form-control" :placeholder="t('global_password')" autocomplete="password" />
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text>@</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="form.change.password2" class="form-control" :placeholder="t('register_repeat-password')" autocomplete="password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="8" offset="2" class="text-center">
                      <b-button variant="primary" block class="px-4" @click="onChange" :disabled="form.change.locked">{{ t('remember_button') }}</b-button>
                    </b-col>
                  </b-row> 
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Login',
  data () {
    return {
      key: undefined,
      form: {
        change: {
          password1: '',
          password2: '',
          alert: {
            danger: ''
          },
          locked: false,
        },
        remember: {
          email: '',
          alert: {
            danger: ''
          },
          locked: false
        }
      }
    }
  },
  methods: {
    onChange () {
      if (this.form.change.locked) return

      const password1 = this.form.change.password1.trim()
      const password2 = this.form.change.password2.trim()

      if (password1 === '' || password2 === '') {
        this.form.change.alert.danger = this.$translate.text('register_please-enter-your-credentials')
      } else if (password1 !== password2) {
        this.form.change.alert.danger = this.$translate.text('register_passwords-doesnt-match')
      } else {
        this.form.change.locked = true

        Vue.axios({
          method: 'POST',
          url: '/user/remember/' + this.key,
          data: {
            password: this.form.change.password1
          },
          mode: 'no-cors',
          withCredentials: true,
          credentials: 'same-origin'
        }).then(response => {
          if (response.data.status) {
            Vue.swal(
              this.$translate.text('remember_changed'),
              '',
              'success')
          } else {
            this.form.change.alert.danger = response.data.message ? this.$translate.text(response.data.message) : this.$translate.text('global_an-unexpected-error-occurred')

            this.form.change.locked = false
          }
        }).catch(() => {
          this.form.change.alert.danger = this.$translate.text('global_an-unexpected-error-occurred')
          this.form.change.locked = false
        })
      }
    },
    onRemember () {
      if (this.form.remember.locked) return

      this.form.remember.alert.danger = ''

      const email = this.form.remember.email.trim()

      if (email === '') {
        this.form.remember.alert.danger = this.$translate.text('remember_please-enter-your-email')
      } else {
        this.form.remember.locked = true

        Vue.axios({
          method: 'POST',
          url: '/user/remember',
          data: {
            email: this.form.remember.email
          },
          mode: 'no-cors',
          withCredentials: true,
          credentials: 'same-origin'
        }).then(response => {
          if (response.data.status) {
            Vue.swal(
              this.$translate.text('remember_sent'),
              '',
              'success').then((result) => {
                this.$router.push({ name: 'Login' })
              })
          } else {
            this.form.remember.alert.danger = response.data.message ? this.$translate.text(response.data.message) : this.$translate.text('global_an-unexpected-error-occurred')

            this.form.remember.locked = false
          }
        }).catch(() => {
          this.form.remember.alert.danger = this.$translate.text('global_an-unexpected-error-occurred')
          this.form.remember.locked = false
        })
      }
    }
  },
  beforeMount () {
    this.key = this.$route.params.key

    if (!!this.key) {
      Vue.axios({
        method: 'GET',
        url: '/user/remember/' + this.key,
        mode: 'no-cors',
        withCredentials: true,
        credentials: 'same-origin'
      }).then(response => {
        if (!response.data.status) {
          this.key = undefined
          Vue.swal(
            this.$translate.text('remember_invalid'),
            '',
            'warning')
        }
      }).catch(() => {
        this.form.remember.alert.danger = this.$translate.text('global_an-unexpected-error-occurred')
      })
    }
  }
}
</script>
